import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import MadrivoCardDetails from './components/MadrivoCardDetails';
import DiabloCardDetails from './components/DiabloCardDetails';
import BrightReachCardDetails from './components/BrightReachCardDetails';
import BannerEdgeCardDetails from './components/BannerEdgeCardDetails';
import Shift44CardDetails from './components/Shift44CardDetails';
import LeadGroupCardDetails from './components/LeadGroupCardDetails';
import PrivateRoute from './components/PrivateRoute';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />
          <Route path="/dashboard/madrivo-details" element={
            <PrivateRoute>
                <MadrivoCardDetails />
            </PrivateRoute>
          } />
          <Route path="/dashboard/diablo-details" element={
            <PrivateRoute>
                <DiabloCardDetails />
            </PrivateRoute>
          } />
          <Route path="/dashboard/brightreach-details" element={
            <PrivateRoute>
              <BrightReachCardDetails />
            </PrivateRoute>
          } />
          <Route path="/dashboard/banneredge-details" element={
            <PrivateRoute>
              <BannerEdgeCardDetails />
            </PrivateRoute>
          } />
          <Route path="/dashboard/shift44-details" element={
            <PrivateRoute>
              <Shift44CardDetails />
            </PrivateRoute>
          } />
          <Route path="/dashboard/leadgroup-details" element={
            <PrivateRoute>
              <LeadGroupCardDetails />
            </PrivateRoute>
          } />
          <Route path="/" element={<Navigate to="/dashboard" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
